import { render, staticRenderFns } from "./secondthird.vue?vue&type=template&id=48f080b3&"
import script from "./secondthird.vue?vue&type=script&lang=js&"
export * from "./secondthird.vue?vue&type=script&lang=js&"
import style0 from "./secondthird.vue?vue&type=style&index=0&id=48f080b3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f080b3')) {
      api.createRecord('48f080b3', component.options)
    } else {
      api.reload('48f080b3', component.options)
    }
    module.hot.accept("./secondthird.vue?vue&type=template&id=48f080b3&", function () {
      api.rerender('48f080b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/second/secondthird.vue"
export default component.exports